// eslint-disable-next-line import/no-cycle
import {
  dateNumberLogicalOperators,
  dateStringLogicalOperators,
  selectionBasedLogicalOperators, numberLogicalOperators,
  stringLogicalOperators, anniversaryNumberLogicalOperators, geographicalAreaLogicalOperators, dateNullLogicalOperators,
  ageNumberLogicalOperators,
  customGeolocationLogicalOperators,
  existenceLogicalOperators,
  anyValueStringLogicalOperators,
} from '@/composables/segmentations/logicalOperators';
// eslint-disable-next-line import/no-cycle
import getOrderPropertiesSegments from '@/composables/segmentations/themes/common-segments/orderPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import getCartPropertiesSegments from '@/composables/segmentations/themes/common-segments/cartPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import {
  getProductCategoriesPropertiesSegments,
  getProductCombinationsPropertiesSegments,
  getProductPropertiesSegments,
  getProductManufacturersPropertiesSegments,
} from '@/composables/segmentations/themes/common-segments/productPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import { getNavigationContextSegments } from '@/composables/segmentations/themes/common-segments/navigationContextSegment';
// eslint-disable-next-line import/no-cycle
import {
  fetchCampaignsAutomation,
  fetchCampaignsBulk,
  fetchCountries,
  fetchDataSources,
  fetchGroups,
  fetchLists,
  fetchShopsLang,
  fetchTags,
} from '@/composables/segmentations/helpers/fetchData';
// eslint-disable-next-line import/no-cycle
import { fetchCustomSchemas } from '@/composables/custom-data/customData';
// eslint-disable-next-line import/no-cycle
import {
  getOpenedBulkCampaignSegment,
  getClickedBulkCampaignSegment,
  getOpenedAutomationCampaignSegment,
  getClickedAutomationCampaignSegment,
} from '@/composables/segmentations/themes/common-segments/campaignStatsSegment';

/**
 * Get segments definition for attributes / can do / has done
 */
const getAttributesSegments = async (t: Function, size: string, includeContext = false) => {
  const tags = await fetchTags();
  const lists = await fetchLists();
  const groups = await fetchGroups();
  const shopsLang = await fetchShopsLang();
  const countries = await fetchCountries(t);
  const dataSources = await fetchDataSources();

  return {
    id: 'attributes',
    list: [
      {
        id: 'first_name',
        label: 'segmentations.attributes.list.first_name',
        logical_operators: stringLogicalOperators('first_name'),
        ...(includeContext && { context: 'contact.first_name' }),
      },
      {
        id: 'last_name',
        label: 'segmentations.attributes.list.last_name',
        logical_operators: stringLogicalOperators('last_name'),
        ...(includeContext && { context: 'contact.last_name' }),
      },
      {
        id: 'email',
        label: 'segmentations.attributes.list.email',
        logical_operators: stringLogicalOperators('email'),
        ...(includeContext && { context: 'contact.email' }),
      },
      {
        id: 'gender',
        label: 'segmentations.attributes.list.gender',
        logical_operators: selectionBasedLogicalOperators('gender', [{
          label: 'gender.unknown',
          value: 0,
        }, {
          label: 'gender.male',
          value: 1,
        },
        {
          label: 'gender.female',
          value: 2,
        }]),
        ...(includeContext && { context: 'contact.gender' }),
      },
      {
        id: 'opt_in',
        label: 'segmentations.attributes.list.opt_in.label',
        logical_operators: selectionBasedLogicalOperators('opt_in', [
          { label: 'segmentations.attributes.list.opt_in.none', value: 0 },
          { label: 'segmentations.attributes.list.opt_in.simple', value: 1 },
          { label: 'segmentations.attributes.list.opt_in.double', value: 2 },
        ]),
        ...(includeContext && { context: 'contact.opt_in' }),
      },
      {
        id: 'lang',
        label: 'segmentations.attributes.list.lang',
        logical_operators: selectionBasedLogicalOperators('lang', shopsLang),
        ...(includeContext && { context: 'contact.lang' }),
      },
      {
        id: 'country',
        label: 'segmentations.attributes.list.country',
        logical_operators: selectionBasedLogicalOperators('country', countries),
        ...(includeContext && { context: 'contact.country' }),
      },
      {
        id: 'geographical_area',
        label: 'segmentations.attributes.list.geographical_area.label',
        logical_operators: geographicalAreaLogicalOperators('geographical_area', size),
      },
      {
        id: 'contact_address',
        label: 'segmentations.attributes.list.contact_address.label',
        sub_properties: [
          {
            id: 'address1',
            label: 'segmentations.attributes.list.contact_address.list.address1',
            logical_operators: stringLogicalOperators('address1'),
          },
          {
            id: 'address2',
            label: 'segmentations.attributes.list.contact_address.list.address2',
            logical_operators: stringLogicalOperators('address2'),
          },
          {
            id: 'postcode',
            label: 'segmentations.attributes.list.contact_address.list.postcode',
            logical_operators: [
              {
                type: 'string',
                data: stringLogicalOperators('postcode'),
              },
              {
                type: 'number',
                data: numberLogicalOperators('postcode'),
              },
            ],
          },
          {
            id: 'region',
            label: 'segmentations.attributes.list.contact_address.list.region',
            logical_operators: stringLogicalOperators('region'),
          },
          {
            id: 'city',
            label: 'segmentations.attributes.list.contact_address.list.city',
            logical_operators: stringLogicalOperators('city'),
          },
          {
            id: 'country',
            label: 'segmentations.attributes.list.contact_address.list.country',
            logical_operators: selectionBasedLogicalOperators('country', countries),
          },
          {
            id: 'first_name',
            label: 'segmentations.attributes.list.contact_address.list.first_name',
            logical_operators: stringLogicalOperators('first_name'),
          },
          {
            id: 'last_name',
            label: 'segmentations.attributes.list.contact_address.list.last_name',
            logical_operators: stringLogicalOperators('last_name'),
          },
          {
            id: 'company',
            label: 'segmentations.attributes.list.contact_address.list.company',
            logical_operators: stringLogicalOperators('company'),
          },
          {
            id: 'date',
            label: 'segmentations.attributes.list.contact_address.list.date',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('date'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('date'),
              },
            ],
          },
        ],
      },
      {
        id: 'birthday',
        label: 'segmentations.attributes.list.birthday',
        logical_operators: [
          {
            type: 'dateNull',
            data: dateNullLogicalOperators('birthday'),
          },
          {
            type: 'dateString',
            data: dateStringLogicalOperators('birthday'),
          },
          {
            type: 'dateNumber',
            data: dateNumberLogicalOperators('birthday'),
          },
          {
            type: 'ageNumber',
            data: ageNumberLogicalOperators('birthday'),
          },
          {
            type: 'anniversaryNumber',
            data: anniversaryNumberLogicalOperators('birthday'),
          },
        ],
        ...(includeContext && { context: 'contact.birthday' }),
      },
      {
        id: 'date',
        label: 'segmentations.attributes.list.date_creation',
        logical_operators: [
          {
            type: 'dateNull',
            data: dateNullLogicalOperators('date'),
          },
          {
            type: 'dateString',
            data: dateStringLogicalOperators('date'),
          },
          {
            type: 'dateNumber',
            data: dateNumberLogicalOperators('date'),
          },
          {
            type: 'anniversaryNumber',
            data: anniversaryNumberLogicalOperators('date'),
          },
        ],
        ...(includeContext && { context: 'contact.date_creation' }),
      },
      {
        id: 'has_a_tag',
        label: 'segmentations.attributes.list.has_a_tag',
        logical_operators: selectionBasedLogicalOperators('has_a_tag', tags),
      },
      {
        id: 'present_in_lists',
        label: 'segmentations.attributes.list.present_in_lists',
        logical_operators: selectionBasedLogicalOperators('present_in_lists', lists),
      },
      {
        id: 'present_in_groups',
        label: 'segmentations.attributes.list.present_in_groups',
        logical_operators: selectionBasedLogicalOperators('present_in_groups', groups),
      },
      ...(dataSources.length > 0 ? [
        {
          id: 'contact_data_source',
          label: 'segmentations.attributes.list.contact_data_source',
          logical_operators: selectionBasedLogicalOperators('contact_data_source', dataSources),
        },
      ] : []),
      // Runtime-only — `isMobileVersion` n'a pas d'équivalent colonne SQL
      // dans `shops_contacts`, donc cet attribut n'est disponible que dans
      // les contextes runtime (workflow conditional / box trigger), pas en
      // segmentation de liste classique.
      ...(includeContext ? [{
        id: 'is_on_mobile',
        label: 'segmentations.attributes.list.is_on_mobile',
        options: [
          { label: 'yes', value: 'true' },
          { label: 'no', value: 'false' },
        ],
        context: 'isMobileVersion',
      }] : []),
      {
        id: 'last_view',
        label: 'segmentations.attributes.list.last_view',
        logical_operators: [
          {
            type: 'dateNull',
            data: dateNullLogicalOperators('last_view'),
          },
          {
            type: 'dateString',
            data: dateStringLogicalOperators('last_view'),
          },
          {
            type: 'dateNumber',
            data: dateNumberLogicalOperators('last_view'),
          },
        ],
      },
      {
        id: 'last_click',
        label: 'segmentations.attributes.list.last_click',
        logical_operators: [
          {
            type: 'dateNull',
            data: dateNullLogicalOperators('last_click'),
          },
          {
            type: 'dateString',
            data: dateStringLogicalOperators('last_click'),
          },
          {
            type: 'dateNumber',
            data: dateNumberLogicalOperators('last_click'),
          },
        ],
      },
      {
        id: 'last_order',
        label: 'segmentations.attributes.list.last_order',
        logical_operators: [
          {
            type: 'dateNull',
            data: dateNullLogicalOperators('last_order'),
          },
          {
            type: 'dateString',
            data: dateStringLogicalOperators('last_order'),
          },
          {
            type: 'dateNumber',
            data: dateNumberLogicalOperators('last_order'),
          },
        ],
      },
      {
        id: 'vouchers',
        label: 'segmentations.attributes.list.vouchers.label',
        sub_properties: [
          {
            id: 'code',
            label: 'segmentations.attributes.list.vouchers.list.code',
            logical_operators: stringLogicalOperators('code'),
          },
          {
            id: 'date_to',
            label: 'segmentations.attributes.list.vouchers.list.date_to',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('date_to'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('date_to'),
              },
            ],
          },
        ],
      },
    ],
  };
};

const getCanDoSegments = async () => ({
  id: 'canDo',
  list: [
    {
      id: 'receive_email',
      label: 'segmentations.canDo.list.receive_email',
      options: [
        { label: 'segmentations.canDo.options.no', value: 'no' },
        { label: 'segmentations.canDo.options.transactional', value: 'transactional' },
        { label: 'segmentations.canDo.options.marketing', value: 'marketing' },
      ],
      data: 'transactional',
    },
    {
      id: 'receive_sms',
      label: 'segmentations.canDo.list.receive_sms',
      options: [
        { label: 'segmentations.canDo.options.no', value: 'no' },
        { label: 'segmentations.canDo.options.transactional', value: 'transactional' },
        { label: 'segmentations.canDo.options.marketing', value: 'marketing' },
      ],
      data: 'transactional',
    },
    {
      id: 'receive_notification_push',
      label: 'segmentations.canDo.list.receive_notification_push',
      options: [
        { label: 'yes', value: true },
        { label: 'no', value: false },
      ],
      data: true,
    },
    {
      id: 'receive_whatsapp',
      label: 'segmentations.canDo.list.receive_whatsapp',
      options: [
        { label: 'segmentations.canDo.options.no', value: 'no' },
        { label: 'segmentations.canDo.options.transactional', value: 'transactional' },
        { label: 'segmentations.canDo.options.marketing', value: 'marketing' },
      ],
      data: 'transactional',
    },
    {
      id: 'receive_rcs',
      label: 'segmentations.canDo.list.receive_rcs',
      options: [
        { label: 'segmentations.canDo.options.no', value: 'no' },
        { label: 'segmentations.canDo.options.transactional', value: 'transactional' },
        { label: 'segmentations.canDo.options.marketing', value: 'marketing' },
      ],
      data: 'transactional',
    },
    {
      id: 'tracking_consent',
      label: 'segmentations.canDo.list.tracking_consent',
      options: [
        { label: 'yes', value: true },
        { label: 'no', value: false },
      ],
      data: true,
    },
  ],
});

/**
 * includeVisitSession: « Visité des URLs » gains « Sur la session en cours »,
 * « Durée de visite » and the « l'une de » operators (on-site triggers only).
 */
const getHasDoneSegments = async (includeContext = false, includeVisitSession = false) => {
  const orderProperties = await getOrderPropertiesSegments();
  const cartProperties = await getCartPropertiesSegments(includeContext);
  const productProperties = await getProductPropertiesSegments();
  const productCombinations = await getProductCombinationsPropertiesSegments();
  const productsCategoriesProperties = await getProductCategoriesPropertiesSegments();
  const productsManufacturersProperties = await getProductManufacturersPropertiesSegments();
  // The four campaign segments share only two lists.
  const [campaignsBulk, campaignsAutomation] = await Promise.all([
    fetchCampaignsBulk(),
    fetchCampaignsAutomation(),
  ]);
  const [openedBulk, clickedBulk, openedAutomation, clickedAutomation] = await Promise.all([
    getOpenedBulkCampaignSegment(campaignsBulk),
    getClickedBulkCampaignSegment(campaignsBulk),
    getOpenedAutomationCampaignSegment(campaignsAutomation),
    getClickedAutomationCampaignSegment(campaignsAutomation),
  ]);

  if (!productProperties.some((property: any) => property.id === 'products_combinations')) {
    productProperties.push({
      id: 'products_combinations',
      label: 'segmentations.products.combinations.title',
      sub_properties: productCombinations,
    });
  }

  return {
    id: 'hasDone',
    list: [
      {
        id: 'created_account',
        label: 'segmentations.hasDone.list.created_account',
        options: [
          { label: 'yes', value: true },
          { label: 'no', value: false },
        ],
        data: true,
      },
      openedBulk,
      openedAutomation,
      clickedBulk,
      clickedAutomation,
      {
        id: 'placed_order',
        label: 'segmentations.hasDone.list.placed_order.label',
        sub_properties: [
          {
            id: 'orders_attributes',
            label: 'segmentations.hasDone.list.placed_order.list.orders_attributes.label',
            sub_properties: orderProperties,
          },
          {
            id: 'id_shop_order',
            label: 'segmentations.hasDone.list.placed_order.list.id_order_count',
            logical_operators: numberLogicalOperators('id_shop_order', [], true),
            aggregate: 'count',
          },
          {
            id: 'amount',
            label: 'segmentations.hasDone.list.placed_order.list.amount_sum',
            logical_operators: numberLogicalOperators('amount'),
            aggregate: 'sum',
            hasCurrency: true,
          },
        ],
      },
      {
        id: 'has_pending_order',
        label: 'segmentations.hasDone.list.has_pending_order.label',
        sub_properties: [
          {
            id: 'pending_order_attributes',
            label: 'segmentations.hasDone.list.has_pending_order.list.pending_order_attributes.label',
            sub_properties: orderProperties,
          },
        ],
      },
      {
        id: 'has_pending_cart',
        label: 'segmentations.hasDone.list.has_pending_cart.label',
        sub_properties: [
          {
            id: 'pending_cart_attributes',
            label: 'segmentations.hasDone.list.has_pending_cart.list.pending_cart_attributes.label',
            sub_properties: cartProperties,
          },
        ],
      },
      {
        id: 'has_no_pending_cart',
        label: 'segmentations.hasDone.list.has_no_pending_cart',
      },
      {
        id: 'visited_products',
        label: 'segmentations.hasDone.list.visited_products.label',
        sub_properties: [
          {
            id: 'product_visited_attributes',
            label: 'segmentations.hasDone.list.visited_products.list.product_visited_attributes.label',
            sub_properties: productProperties,
          },
          {
            id: 'nb_views',
            label: 'segmentations.hasDone.list.visited_products.list.visited_products_count',
            logical_operators: numberLogicalOperators('nb_views', [], true),
            aggregate: 'sum',
          },
          {
            id: 'products_visited_date',
            label: 'segmentations.hasDone.list.visited_products.list.products_visited_date',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('products_visited_date'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('products_visited_date', undefined, includeContext),
              },
            ],
          },
        ],
      },
      {
        id: 'visited_categories',
        label: 'segmentations.hasDone.list.visited_categories.label',
        sub_properties: [
          {
            id: 'category_visited_attributes',
            label: 'segmentations.hasDone.list.visited_categories.list.category_visited_attributes.label',
            sub_properties: productsCategoriesProperties,
          },
          {
            id: 'nb_views',
            label: 'segmentations.hasDone.list.visited_categories.list.visited_categories_count',
            logical_operators: numberLogicalOperators('nb_views', [], true),
            aggregate: 'sum',
          },
          {
            id: 'categories_visited_date',
            label: 'segmentations.hasDone.list.visited_categories.list.categories_visited_date',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('categories_visited_date'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('categories_visited_date', undefined, includeContext),
              },
            ],
          },
        ],
      },
      {
        id: 'visited_manufacturers',
        label: 'segmentations.hasDone.list.visited_manufacturers.label',
        sub_properties: [
          {
            id: 'manufacturer_visited_attributes',
            label: 'segmentations.hasDone.list.visited_manufacturers.list.manufacturer_visited_attributes.label',
            sub_properties: productsManufacturersProperties,
          },
          {
            id: 'nb_views',
            label: 'segmentations.hasDone.list.visited_manufacturers.list.visited_manufacturers_count',
            logical_operators: numberLogicalOperators('nb_views', [], true),
            aggregate: 'sum',
          },
          {
            id: 'manufacturers_visited_date',
            label: 'segmentations.hasDone.list.visited_manufacturers.list.manufacturers_visited_date',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('manufacturers_visited_date'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('manufacturers_visited_date', undefined, includeContext),
              },
            ],
          },
        ],
      },
      {
        id: 'subscribed_to_push',
        label: 'segmentations.hasDone.list.subscribed_to_push.label',
        sub_properties: [
          {
            id: 'date_creation',
            label: 'segmentations.hasDone.list.subscribed_to_push.list.date_subscription',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('date_creation'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('date_creation'),
              },
            ],
          },
        ],
      },
      {
        id: 'visited_urls',
        label: 'segmentations.hasDone.list.visited_urls.label',
        sub_properties: [
          {
            id: 'url_visited',
            label: 'segmentations.hasDone.list.visited_urls.list.url_visited.label',
            logical_operators: includeVisitSession
              ? { ...stringLogicalOperators('url_visited'), ...anyValueStringLogicalOperators('url_visited') }
              : stringLogicalOperators('url_visited'),
          },
          {
            id: 'nb_views',
            label: 'segmentations.hasDone.list.visited_urls.list.visited_url_count',
            logical_operators: numberLogicalOperators('nb_views', [], true),
            aggregate: 'sum',
          },
          {
            id: 'url_visited_date',
            label: 'segmentations.hasDone.list.visited_urls.list.url_visited_date',
            logical_operators: [
              {
                type: 'dateString',
                data: dateStringLogicalOperators('url_visited_date'),
              },
              {
                type: 'dateNumber',
                data: dateNumberLogicalOperators('url_visited_date', undefined, includeContext),
              },
            ],
          },
          ...(includeVisitSession ? [
            {
              id: 'in_current_session',
              label: 'segmentations.hasDone.list.visited_urls.list.in_current_session',
              options: [
                { label: 'yes', value: true },
                { label: 'no', value: false },
              ],
              data: true,
            },
            {
              id: 'time_on_page',
              label: 'segmentations.hasDone.list.visited_urls.list.time_on_page',
              logical_operators: numberLogicalOperators('time_on_page', [
                'number_greater_than_or_equal_to',
                'number_greater_than',
              ]),
            },
          ] : []),
        ],
      },
    ],
  };
};

const getCustomAttributesSegments = async (t: Function, size: string, includeContext = false) => {
  const customSchemas = await fetchCustomSchemas();

  // Filter schemas that have a relationship with customers
  const customerRelatedSchemas = customSchemas.filter((schema: any) => {
    if (!schema.relationships || !Array.isArray(schema.relationships)) {
      return false;
    }

    return schema.relationships.some(
      (rel: any) => rel.targetSchemaType === 'system' && rel.targetSchema === 'contacts',
    );
  });

  // Helper function to create field properties recursively
  const createFieldProperties = async (
    field: any,
    sourceSchema: any,
    allSchemas: any[],
    contextPath = '',
  ) => {
    // Check if this field has a relationship with another schema
    const relationship = sourceSchema.relationships?.find(
      (rel: any) => rel.sourceField === field.name
    );

    // If no relationship, create a simple field property
    if (!relationship) {
      // Determine logical operators based on field type
      let logicalOperators = {};

      switch (field.type) {
        case 'text':
          logicalOperators = stringLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`);
          break;
        case 'number':
          logicalOperators = numberLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`);
          break;
        case 'date':
          logicalOperators = dateStringLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`);
          break;
        case 'boolean':
          logicalOperators = selectionBasedLogicalOperators(
            `custom_${sourceSchema.id_custom_object}_${field.name}`,
            [
              { label: t('common.yes'), value: true },
              { label: t('common.no'), value: false },
            ],
          );
          break;
        case 'geolocation':
          logicalOperators = customGeolocationLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`, size);
          break;
        default:
          // Default to string operators if type is unknown
          logicalOperators = stringLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`);
          break;
      }

      const property: any = {
        id: `custom_${sourceSchema.id_custom_object}_${field.name}`,
        label: field.label || field.name,
        logical_operators: logicalOperators,
        isCustomAttribute: true,
      };

      // Add context path if includeContext is true
      if (includeContext && contextPath) {
        property.context = `${contextPath}.${field.name}`;
      }

      return property;
    }

    // Handle system schema relationships
    if (relationship.targetSchemaType === 'system') {
      // Handle products relationship
      if (relationship.targetSchema === 'products' && relationship.targetField === 'product_id') {
        const productProperties = await getProductPropertiesSegments();

        return {
          id: `custom_${sourceSchema.id_custom_object}_${field.name}`,
          label: `${field.name} (Produits)`,
          sub_properties: productProperties,
          isCustomAttribute: true,
        };
      }

      // For other system relationships, create a simple field for now
      return {
        id: `custom_${sourceSchema.id_custom_object}_${field.name}`,
        label: field.label || field.name,
        logical_operators: stringLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`),
        isCustomAttribute: true,
      };
    }

    // Handle custom schema relationships
    if (relationship.targetSchemaType === 'custom') {
      // Find the target schema
      const targetSchema = allSchemas.find(
        (schema) => schema.id_custom_object.toString() === relationship.targetSchema.toString(),
      );

      // If target schema not found, return simple field
      if (!targetSchema) {
        return {
          id: `custom_${sourceSchema.id_custom_object}_${field.name}`,
          label: field.label || field.name,
          logical_operators: stringLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`),
          isCustomAttribute: true,
        };
      }

      // Create sub-properties for the target schema fields
      // EXTEND the contextPath with the target schema table_name for nested joins
      // Example: contact.custom.schema1 -> contact.custom.schema1.schema2
      const extendedContextPath = contextPath && includeContext
        ? `${contextPath}.${targetSchema.table_name}`
        : contextPath;
      const subProperties = await Promise.all(
        targetSchema.fields.map((targetField: any) => createFieldProperties(targetField, targetSchema, allSchemas, extendedContextPath)),
      );

      // Return a complex segment
      return {
        id: `custom_${sourceSchema.id_custom_object}_${field.name}`,
        label: `${field.name} (${targetSchema.schema_name})`,
        sub_properties: subProperties,
        isCustomAttribute: true,
      };
    }

    // Default fallback
    return {
      id: `custom_${sourceSchema.id_custom_object}_${field.name}`,
      label: field.label || field.name,
      logical_operators: stringLogicalOperators(`custom_${sourceSchema.id_custom_object}_${field.name}`),
      isCustomAttribute: true,
    };
  };

  // Create segments for each schema
  const segmentsList = await Promise.all(
    customerRelatedSchemas.map(async (schema: any) => {
      if (!schema.relationships || !Array.isArray(schema.relationships)) {
        return [];
      }
      // Find the field name used for customer relationship to exclude it
      const customerRelationFields = schema.relationships
        .filter((rel: any) => rel.targetSchemaType === 'system' && rel.targetSchema === 'contacts')
        .map((rel: any) => rel.sourceField);

      // Create sub-properties for each field in the schema, excluding customer relation fields
      // Initialize contextPath with contact.custom.{table_name}
      const initialContextPath = includeContext ? `contact.custom.${schema.table_name}` : '';
      const subProperties = (
        await Promise.all(
          schema.fields
            .filter((field: any) => !customerRelationFields.includes(field.name))
            .map((field: any) => createFieldProperties(field, schema, customSchemas, initialContextPath)),
        )
      ).map((property: any) => {
        // "n'existe pas" targets the record itself, not a field: the engine reads
        // the operator and ignores which field carried it. Offer it on every simple
        // field of a root object (which always has a contacts relation). Relation
        // sub-trees carry sub_properties and are skipped — there the meaning would
        // be ambiguous.
        if (!property || !property.logical_operators || 'sub_properties' in property) {
          return property;
        }
        return {
          ...property,
          logical_operators: {
            ...property.logical_operators,
            ...existenceLogicalOperators(),
          },
        };
      });

      // Return segment for this schema
      return {
        id: `custom_${schema.id_custom_object}`,
        label: schema.schema_name,
        sub_properties: subProperties,
        isCustomAttribute: true,
      };
    }),
  );

  return {
    id: 'customAttributes',
    list: segmentsList,
  };
};

/**
 * Get theme contacts definition
 */
const getThemeContactsDefinition = async (t: Function, size: string, includeContext = false, includeVisitSession = false) => {
  try {
    const [attributes, customAttributes, canDo, hasDone, navigationContext] = await Promise.all([
      getAttributesSegments(t, size, includeContext),
      getCustomAttributesSegments(t, size, includeContext),
      getCanDoSegments(),
      getHasDoneSegments(includeContext, includeVisitSession),
      getNavigationContextSegments(includeContext),
    ]);

    const groupProperties: any = [attributes];
    if (customAttributes.list.length > 0) {
      groupProperties.push(customAttributes);
    }
    groupProperties.push(canDo);
    groupProperties.push(hasDone);
    if (includeContext) {
      groupProperties.push(navigationContext);
    }
    return groupProperties;
  } catch (error) {
    console.error('An error occurred while fetching segments: re', error);
  }
  return [];
};

export {
  getAttributesSegments,
  getCustomAttributesSegments,
  getThemeContactsDefinition,
  getHasDoneSegments,
};
